export default __webpack_public_path__ + "static/travel-back-in-time-visit-athens-6a87f4463313eedef732f915bd459f75.jpg";